import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from 'contentful';

import type { TypeBannerSkeleton } from './TypeBanner';
import type { TypeBlockArticlesSkeleton } from './TypeBlockArticles';
import type { TypeBlockContentSkeleton } from './TypeBlockContent';
import type { TypeBlockCtaSkeleton } from './TypeBlockCta';
import type { TypeBlockFaqSkeleton } from './TypeBlockFaq';
import type { TypeBlockLegalTextSkeleton } from './TypeBlockLegalText';
import type { TypeBlockProductsSkeleton } from './TypeBlockProducts';
import type { TypeBlockPromoSkeleton } from './TypeBlockPromo';
import type { TypeBlockQuickLinkSkeleton } from './TypeBlockQuickLink';
import type { TypeBlockTextSkeleton } from './TypeBlockText';
import type { TypeBlockValuePromptSkeleton } from './TypeBlockValuePrompt';
import type { TypeLeadFormSkeleton } from './TypeLeadForm';

export interface TypeBlockWidgetFields {
    internalName: EntryFieldTypes.Symbol;
    type: EntryFieldTypes.Symbol<'CoverageMap' | 'FeedbackForm' | 'PlansList' | 'SpeedTest'>;
    configuration?: EntryFieldTypes.Object;
    relatedContent?: EntryFieldTypes.Array<
        EntryFieldTypes.EntryLink<
            | TypeBannerSkeleton
            | TypeBlockArticlesSkeleton
            | TypeBlockContentSkeleton
            | TypeBlockCtaSkeleton
            | TypeBlockFaqSkeleton
            | TypeBlockLegalTextSkeleton
            | TypeBlockProductsSkeleton
            | TypeBlockPromoSkeleton
            | TypeBlockQuickLinkSkeleton
            | TypeBlockTextSkeleton
            | TypeBlockValuePromptSkeleton
            | TypeBlockWidgetSkeleton
            | TypeLeadFormSkeleton
        >
    >;
}

export type TypeBlockWidgetSkeleton = EntrySkeletonType<TypeBlockWidgetFields, 'blockWidget'>;
export type TypeBlockWidget<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<
    TypeBlockWidgetSkeleton,
    Modifiers,
    Locales
>;

export function isTypeBlockWidget<Modifiers extends ChainModifiers, Locales extends LocaleCode>(
    entry: unknown,
): entry is TypeBlockWidget<Modifiers, Locales> {
    const candidate = entry as { sys?: { contentType?: { sys?: { id?: string } } } };

    return candidate.sys?.contentType?.sys?.id === 'blockWidget';
}
